import React, { useState } from 'react';
import { PanelLeft, PanelLeftClose } from 'lucide-react';
import Header from '../../components/Header/Header';
import HeroSection from '../../components/HeroSection/HeroSection';
import Features from '../../components/Features/Features';
import FeaturedProducts from '../../components/FeaturedProducts/FeaturedProducts';
import CategorySidebar from '../../components/CategorySidebar/CategorySidebar';
import './Homepage.css';

function Homepage() {
  const [categorySidebarOpen, setCategorySidebarOpen] = useState(false);

  return (
    <div className="homepage">
      <Header />
      <div className="main-content">
        <button
          type="button"
          className="mobile-category-toggle"
          onClick={() => setCategorySidebarOpen(prev => !prev)}
          aria-label={categorySidebarOpen ? 'Hide categories' : 'Show categories'}
        >
          {categorySidebarOpen ? <PanelLeftClose size={18} /> : <PanelLeft size={18} />}
          {categorySidebarOpen ? 'Hide Categories' : 'Browse Categories'}
        </button>
        <CategorySidebar
          visible={categorySidebarOpen}
          onClose={() => setCategorySidebarOpen(false)}
        />
        <div className="content-wrapper">
          <HeroSection />
          <Features />
          <FeaturedProducts />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
